import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Tooltip,
    styled,
} from '@mui/material';

const LevelsCell = (params: any) => {
    const levelsLanguage = params?.colDef?.headerName === "levels_es" ? "es" : "en"

    if (typeof params.value === 'string') {
        const levels: any[] = JSON.parse(params.value)
        params.eGridCell.classList.add("no-padding");

        const StyledTableRow = styled(TableRow)(() => ({
            "& td": {
                borderBottom: "1px solid #F0F0F0",
            },
            "&:last-child td": { border: 0 }
        }));

        const cellTextStyle = {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: 0,
            overflow: 'hidden',
        };

        const hasLevels = levels.filter((l) => levelsLanguage === 'en' ? !!l.label : !!l.label_es).length > 0;

        return (
            hasLevels ?
                <TableContainer
                    sx={{
                        width: '100%',
                    }}
                >
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ background: '#eee' }}>Value</TableCell>
                                <TableCell style={{ background: '#eee' }}>Label</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {levels
                                .filter((level) => levelsLanguage === 'en' ? !!level?.label : !!level?.label_es)
                                .map((level: any, index: number) => {
                                    return (
                                        <StyledTableRow key={`row${index}`}>
                                            <TableCell style={cellTextStyle}>
                                                <Tooltip title={level.value}>
                                                    <span>{level?.value}</span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell style={cellTextStyle}>
                                                <Tooltip title={level.label}>
                                                    {levelsLanguage === 'en' ?
                                                        <span>{level?.label || ""}</span> :
                                                        <span>{level?.label_es || ""}</span>
                                                    }
                                                </Tooltip>
                                            </TableCell>
                                        </StyledTableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer> :
                null
        )
    }
    return params.value;
}

export default LevelsCell;